import { RootState } from "../../../system/redux/store/community-finder-redux-store";

export const selectInitialFacets = (state: RootState) =>
	state?.facets?.initialFacets;
